import { render, staticRenderFns } from "./ShopData.vue?vue&type=template&id=69db434c&scoped=true&"
import script from "./ShopData.vue?vue&type=script&lang=js&"
export * from "./ShopData.vue?vue&type=script&lang=js&"
import style0 from "./ShopData.vue?vue&type=style&index=0&id=69db434c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69db434c",
  null
  
)

export default component.exports